const TokenKey = 'TrackVisionToken'
const UserKey = 'TrackVisionUser'
const LiteKey = 'TrackVisionLite'

export function getToken() {
    if (localStorage.getItem(TokenKey)) {
        return localStorage.getItem(TokenKey)
    } else {
        return
    }
}

export function getUser() {
    if (localStorage.getItem(UserKey)) {
        return JSON.parse(localStorage.getItem(UserKey))
    } else {
        return
    }
}

export function setToken(isLite,token, user) {
    localStorage.setItem(LiteKey, isLite)
    localStorage.setItem(TokenKey, token)
    localStorage.setItem(UserKey, user)
}

export function updateUser(user) {
    localStorage.setItem(UserKey, JSON.stringify(user))
}

export function removeToken() {
    localStorage.removeItem(TokenKey)
    localStorage.removeItem(UserKey)
    localStorage.removeItem(LiteKey)
}

export function getLite() {
    if (localStorage.getItem(LiteKey)) {
        return localStorage.getItem(LiteKey)
    } else {
        return false
    }
}

export function setLite(isLite) {
    localStorage.setItem(LiteKey, isLite)
} 